function handleTermsCheckbox(isChecked) {
  const drawerCheckbox = document.getElementById('drawer-checkbox-terms');
  const cartCheckbox = document.getElementById('cart-checkbox-terms');
  if (drawerCheckbox) drawerCheckbox.checked = isChecked;
  if (cartCheckbox) cartCheckbox.checked = isChecked;
  if (isChecked) {
    sessionStorage.setItem('termsAccepted', 'true');
    const errorMessages = document.querySelectorAll('[data-terms-error-message]');
    errorMessages.forEach(message => message.classList.add('hidden'));
  } else {
    sessionStorage.removeItem('termsAccepted');
  }
}

function initializeTermsCheckbox() {
  const termsAccepted = sessionStorage.getItem('termsAccepted');
  const drawerCheckbox = document.getElementById('drawer-checkbox-terms');
  const cartCheckbox = document.getElementById('cart-checkbox-terms');
  if (termsAccepted === 'true') {
    if (drawerCheckbox) drawerCheckbox.checked = true;
    if (cartCheckbox) cartCheckbox.checked = true;
  } else {
    if (drawerCheckbox) drawerCheckbox.checked = false;
    if (cartCheckbox) cartCheckbox.checked = false;
  }
}

document.addEventListener('DOMContentLoaded', initializeTermsCheckbox);

document.addEventListener('change', function(event) {
  if (event.target.hasAttribute('data-terms-checkbox')) {
    handleTermsCheckbox(event.target.checked);
  }
});

function validateCheckoutTerms(event) {
  if (event.target.name === "checkout" || event.target.className == "cart-drawer__button-price") {
    const container = event.target.closest('div');
    const checkbox = container.querySelector('[data-terms-checkbox]');
    const termsEnabled = checkbox !== null;
    
    if (termsEnabled && !checkbox.checked) {
      event.preventDefault();
      
      const errorMessage = container.querySelector('[data-terms-error-message]');
      if (errorMessage) {
        errorMessage.classList.remove('hidden');
        checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }
  }
}

document.addEventListener('click', validateCheckoutTerms);